/**
 * Premium homepage hero — content + AI-native architecture visualization.
 */
import React, {useState} from 'react';
import "./Hero.css";
import HeroContent from "./HeroContent";
import HeroVisualization from "./HeroVisualization";
import {useHeroAnimation} from "./useHeroAnimation";

export default function Hero() {
    const [hoverSlow, setHoverSlow] = useState(false);
    const {phase, reducedMotion} = useHeroAnimation(hoverSlow);

    return (
        <header className="hx-hero wx-hero">
            <div className="wx-container">
                <div className="hx-grid">
                    <HeroContent/>
                    <HeroVisualization
                        phase={phase}
                        reducedMotion={reducedMotion}
                        hoverSlow={hoverSlow}
                        onHoverChange={setHoverSlow}
                    />
                </div>
            </div>
        </header>
    );
}
